import { FC } from 'react';

const IllustrationOffline: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
  >
    <path
      fill="#1D1D1D"
      d="M29.85 16.25a5.93 5.93 0 0 1 2.045-2.725A5.27 5.27 0 0 1 35 12.5a5.27 5.27 0 0 1 3.105 1.025 5.93 5.93 0 0 1 2.045 2.724c4.108 1.22 7.73 3.863 10.313 7.522 2.582 3.658 3.98 8.132 3.981 12.732v14.09l5.089 8.243c.279.452.44.977.464 1.52a3.2 3.2 0 0 1-.325 1.56c-.238.479-.591.879-1.022 1.158s-.925.426-1.428.426H44.625c-.335 2.5-1.492 4.785-3.26 6.437S37.339 72.5 35 72.5s-4.598-.91-6.366-2.563C26.867 68.285 25.71 66 25.375 63.5H12.778c-.503 0-.996-.147-1.428-.426a2.9 2.9 0 0 1-1.021-1.158 3.2 3.2 0 0 1-.326-1.56 3.17 3.17 0 0 1 .464-1.52l5.089-8.243v-14.09c0-9.67 6.055-17.818 14.294-20.254m1.222 47.25a4.5 4.5 0 0 0 1.523 2.176 3.96 3.96 0 0 0 2.406.826c.862 0 1.703-.288 2.407-.826A4.5 4.5 0 0 0 38.93 63.5zM35 21.505c-3.683 0-7.216 1.58-9.82 4.393s-4.069 6.627-4.069 10.605v14.999c0 .592-.162 1.171-.466 1.664l-2.675 4.335h34.058l-2.675-4.335a3.17 3.17 0 0 1-.464-1.664V36.503c0-3.978-1.464-7.793-4.068-10.605-2.605-2.813-6.137-4.393-9.821-4.393"
    ></path>
    <ellipse cx="52.069" cy="22.625" fill="#fff" rx="9.5" ry="10"></ellipse>
    <path
      fill="#E81741"
      fillRule="evenodd"
      d="M62.51 12.67c-5.616-5.617-14.723-5.617-20.34 0s-5.617 14.724 0 20.34c5.617 5.617 14.724 5.617 20.34 0 5.617-5.616 5.617-14.723 0-20.34m-6.519 2.645a1 1 0 0 1 1.414 0l2.46 2.46a1 1 0 0 1 0 1.414l-2.944 2.944a1 1 0 0 0 0 1.415l2.944 2.944a1 1 0 0 1 0 1.414l-2.46 2.46a1 1 0 0 1-1.414 0l-2.944-2.944a1 1 0 0 0-1.414 0l-2.945 2.944a1 1 0 0 1-1.414 0l-2.46-2.46a1 1 0 0 1 0-1.414l2.944-2.945a1 1 0 0 0 0-1.414l-2.944-2.944a1 1 0 0 1 0-1.414l2.46-2.46a1 1 0 0 1 1.414 0l2.944 2.944a1 1 0 0 0 1.415 0z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default IllustrationOffline;
